// extracted by mini-css-extract-plugin
export default {"popover":"AntPopover_popover__Q2g0-"};